<div>
  <div class="align-center pr-medium-y">
    <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.FLIGHTS_UNAVAILABLE" />
    <div class="pr-xsmall-t bold-type" data-testid="title">{{ title() }}</div>
  </div>
  @if (showWarningNotification()) {
    <fcom-notification
      data-testid="warning-notification"
      [theme]="NotificationTheme.WARNING"
      [linkText]="warningNotificationCtaText()"
      (linkClick)="ctaClick.emit($event)"
    >
      {{ warningNotificationCtaText() }}
      {{ warningNotificationMessage() }}
      <ng-content select=".content" />
    </fcom-notification>
  }
</div>
